import { render } from "./SecuritySystem.vue?vue&type=template&id=620c71fa"
import script from "./SecuritySystem.vue?vue&type=script&lang=js"
export * from "./SecuritySystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__